import type { Bucket } from '@apka/core'
import { zl } from './format.js'
import { useLiczbaPlynna } from './liczby.js'
import './licznik.css'

interface Props {
  nazwa: string
  opis: string
  kubelek: Bucket
  wyrozniony?: boolean
}

/**
 * Licznik pokazuje sumę okresu i od razu odpowiada na pytanie „ile już
 * poszło": pasek postępu i podpis rozbijają kwotę na zapłacone i oczekujące.
 * Kwota dobija do nowej wartości, więc widać, że coś się przeliczyło.
 */
export function Licznik({ nazwa, opis, kubelek, wyrozniony = false }: Props) {
  const suma = useLiczbaPlynna(kubelek.total)
  const zaplacone = useLiczbaPlynna(kubelek.paid)
  const oczekujace = useLiczbaPlynna(kubelek.pending)
  const udzial = kubelek.total === 0 ? 0 : Math.round((kubelek.paid / kubelek.total) * 100)

  return (
    <article className={wyrozniony ? 'licznik licznik--wyrozniony karta' : 'licznik karta'}>
      <header className="licznik__naglowek">
        <h2 className="licznik__nazwa">{nazwa}</h2>
        <p className="licznik__opis">{opis}</p>
      </header>

      <p className="licznik__kwota">{zl(suma)}</p>

      <div
        className="licznik__pasek"
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={udzial}
        aria-label={`Zapłacono ${udzial} procent`}
      >
        <span className="licznik__pasek-wypelnienie" style={{ width: `${udzial}%` }} />
      </div>

      <dl className="licznik__rozbicie">
        <div>
          <dt>Zapłacone</dt>
          <dd className="licznik__zaplacone">{zl(zaplacone)}</dd>
        </div>
        <div>
          <dt>Oczekujące</dt>
          <dd>{zl(oczekujace)}</dd>
        </div>
      </dl>
    </article>
  )
}
